import React, { useState } from "react";

import { Phone, Mail, MapPin } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Button } from "../components/ui/Button";
import Categories from "../components/Categories";
import Hero from "../components/Hero";
import { CategoriesSection, StaticFeaturesSection } from "../components/ProductCategories";
import { sendEmail } from "../services/emailService";
import Swal from 'sweetalert2';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

   const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await sendEmail(formData);
    setFormSubmitted(true);

    Swal.fire({
      icon: 'success',
      title: 'Email Sent!',
      text: 'Your message has been successfully delivered.',
      confirmButtonColor: '#73340E',
    });

    setTimeout(() => {
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
      setFormSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error("Email send error:", error.message);
    Swal.fire({
      icon: 'error',
      title: 'Oops!',
      text: 'Something went wrong. Please try again later.',
      confirmButtonColor: '#73340E',
    });
  }
};


  return (
    <main className="min-h-screen bg-[#FBF1EB]">
      {/* <Header /> */}
      <Hero isHome={false} />

      {/* Hero Banner */}
      {/* <div className="relative w-full h-[300px] overflow-hidden">
        <img
          src="/contactpage-banner.png"
          alt="Copper and brass containers"
          className="object-cover w-full h-full"
        />
      </div> */}

      {/* Heading */}
      <div className="w-full py-8 px-4 md:px-8 bg-[#FBF1EB]">
        <h1 className="text-3xl md:text-4xl font-bold text-[#4b2e19] text-center mb-10 drop-shadow-sm">Contact Us</h1>
      </div>

      {/* Info Grid */}
      <section className="w-full py-8 px-4 md:px-8 bg-[#FBF1EB]">
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#C19775] rounded-lg p-6 md:p-8 text-white">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex flex-col items-center text-center">
                <MapPin size={32} className="mb-2" />
                <h3 className="text-lg font-medium mb-2">Our Location</h3>
                <p className="text-sm">
                  <a
                    href="https://www.google.com/maps/place/Rameshwari+Nagar,+Nagpur,+Maharashtra+440027"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline text-sm"
                  >
                    Plot no 170, Jagdamba Krupa, Rameshwari Nagar, Nagpur, Maharashtra 440027
                  </a>
                </p>

              </div>
              <div className="flex flex-col items-center text-center">
                <Phone size={32} className="mb-2" />
                <h3 className="text-lg font-medium mb-2">Phone Number</h3>
                <a href="tel:+919356936283" className="hover:underline text-sm">
                  +91 9356936283
                </a>
              </div>
              <div className="flex flex-col items-center text-center">
                <Mail size={32} className="mb-2" />
                <h3 className="text-lg font-medium mb-2">Email Address</h3>
                <a href="mailto:synergyinnovativeenterprises@gmail.com" className="hover:underline text-sm">
                  synergyinnovativeenterprises@gmail.com
                </a>              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      {/* <section className="w-full py-8 px-4 md:px-8 bg-[#FBF1EB]">
        <div className="max-w-4xl mx-auto">
          <div className="w-full h-[250px] bg-[#C09670] rounded-lg flex items-center justify-center text-white">
            <p>Map Location</p>
          </div>
        </div>
      </section> */}



      {/* Contact Form */}
      <section className="w-full py-8 px-4 md:px-8 bg-[#FBF1EB]">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4b2e19] text-center mb-8 drop-shadow-sm">Let's Connect</h2>

          <form
            onSubmit={handleSubmit}
            className="border border-[#C19775] rounded-lg p-8 md:p-12"
          >
            <div className="mb-6">
              <label htmlFor="name" className="block text-[#34302B] uppercase text-sm mb-2">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full bg-transparent border-b border-[#C19775] focus:outline-none focus:border-[#73340E] py-2 text-[#34302B]"
              />
            </div>

            <div className="mb-6">
              <label htmlFor="email" className="block text-[#34302B] uppercase text-sm mb-2">
                E-mail ID
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-transparent border-b border-[#C19775] focus:outline-none focus:border-[#73340E] py-2 text-[#34302B]"
              />
            </div>

            <div className="mb-6">
              <label htmlFor="subject" className="block text-[#34302B] uppercase text-sm mb-2">
                Subject
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className="w-full bg-transparent border-b border-[#C19775] focus:outline-none focus:border-[#73340E] py-2 text-[#34302B]"
              />
            </div>

            <div className="mb-8">
              <label htmlFor="message" className="block text-[#34302B] uppercase text-sm mb-2">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                className="w-full bg-transparent border-b border-[#C19775] focus:outline-none focus:border-[#73340E] py-2 text-[#34302B] resize-none"
              />
            </div>

            <div className="flex justify-center">
              <Button
                type="submit"
                className="bg-[#73340E] hover:bg-[#C09670] text-white px-8 py-2"
              >
                {formSubmitted ? "Message Sent!" : "Submit"}
              </Button>
            </div>

            {formSubmitted && (
              <p className="mt-4 text-center text-green-600">
                Thank you for your message. We'll get back to you soon!
              </p>
            )}
          </form>
        </div>
      </section>
   <h3 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mt-10 drop-shadow-sm bg-white overflow-hidden">
        SHOP BY CATEGORY
      </h3>
 <CategoriesSection isHome={true} />
      {/* Google Maps Iframe Placeholder */}
      <section className="w-full h-[300px] bg-gray-300">
        <div className="w-full h-full">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14888.143299032838!2d79.07203884697442!3d21.111137869488424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf5cdc60c7eb%3A0x7f7f4d20300351fd!2sRameshwari%20Nagar%2C%20Nagpur%2C%20Maharashtra%20440027!5e0!3m2!1sen!2sin!4v1747672608788!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
      {/* <Footer /> */}

      
    </main>
    
  );
  
};

export default ContactUs;
